import React from "react";
import LegalPageLayout from "../../components/common/LegalPageLayout";
import TermsData from "./termsData";

const Terms = () => (
  <LegalPageLayout
    pageTitle="Terms of Service"
    effectiveDate="May 2, 2026"
    sections={TermsData}
  />
);

export default Terms;
